import type { ImageViewerSlide } from "../interfaces/ImageViewerSlide";

export function useImageViewer() {
  const { openModal } = useZaprooModal();

  function openImageViewer(
    initialIndex: number,
    images: ImageViewerSlide[],
    label?: string,
  ): void {
    openModal(
      defineAsyncComponent(() => import("../modals/ImageViewer.vue")),
      {
        payload: { initialIndex, images, label },
      },
    );
  }

  return {
    openImageViewer,
  };
}
